/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
import constantName from "./key"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}
export function loadDeliverableRecordsMetaDataDetails(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}
export function loadInstructionsRecordsMetaDataDetails(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordQuotationDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_${atob(constantName)}_event`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createQuotationRecord(record, quotationData) {
  console.log("inside api call------------", quotationData)
  try {
    const response = await api.post(
      `/add_lead_${atob(constantName)}_event`,
      record,
      quotationData
    )
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateQuotationRecord(quotationData) {
  try {
    console.log("Updated Api data ---> ")

    const response = await api.post(
      `/update_lead_${atob(constantName)}_event`,
      quotationData
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteQuotationRecord(id, quotationRemoveId) {
  const quotationLeadId = id
  const payload = {
    leadId: quotationLeadId,
    leadQuotationEventId: quotationRemoveId,
  }
  return api
    .post(`/delete_lead_${atob(constantName)}_event`, payload)
    .catch((error) => Promise.reject(error))
}

// Deliverables Api list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadDeliverableDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_${atob(constantName)}_deliverable`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadDeliverableECDetailsData(id) {
  // let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_${atob(constantName)}_deliverable_ec`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createDeliverable(record, deliverData) {
  console.log("inside api call------------", deliverData)
  try {
    const response = await api.post(
      `/add_lead_${atob(constantName)}_deliverable`,
      record,
      deliverData
    )
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateDeliverable(deliverData) {
  try {
    console.log("Updated Api data ---> ")

    const response = await api.post(
      `/update_lead_${atob(constantName)}_deliverable`,
      deliverData
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteDeliverable(id, deliverableRemoveId) {
  const deliverLeadId = id
  const payload = {
    leadId: deliverLeadId,
    leadQuotationDeliverableId: deliverableRemoveId,
  }
  return api
    .post(`/delete_lead_${atob(constantName)}_deliverable`, payload)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export async function loadServiceDetails(searchFilter) {
  // let payload = { status: "active", leadId: id }

  if (searchFilter) {
    return await api
      .post(`/get_all_service`, searchFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_all_service`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//Expiry Date
/**
 *
 * @param {integer} id
 * @returns
 */

export function updateExpiryDateDetails(expiryDate) {
  return api
    .post(`/update_quotation_expiry`, expiryDate)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Instructions API list
/**
 *
 * @param {integer} id
 * @returns
 */

export function loadValueInsertDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_${atob(constantName)}_special_instruction`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createValueInsertDetails(valueInsert) {
  console.log("inside api call------------", valueInsert)
  try {
    const response = await api.post(
      `/update_quotation_insert_amount`,
      valueInsert
    )
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateValueInsertDetails(valueInsert) {
  try {
    if (
      valueInsert &&
      (valueInsert.insertedAmount || valueInsert.insertedPercentage)
    ) {
      const response = await api.post(
        `/update_quotation_insert_amount`,
        valueInsert
      )
      return Promise.resolve(response.data)
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteValueInsertDetails(valueInsert) {
  // const payload = {
  //   leadId: id,
  //   leadInsertId: insertId,
  // }
  return api
    .post(`/update_quotation_insert_amount`, valueInsert)
    .catch((error) => Promise.reject(error))
}
//Instructions API list
/**
 *
 * @param {integer} id
 * @returns
 */

export function loadInstructions(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_${atob(constantName)}_special_instruction`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createInstruction(specialInstructions) {
  console.log("inside api call------------", specialInstructions)
  try {
    const response = await api.post(
      `/add_lead_${atob(constantName)}_special_instruction`,
      specialInstructions
    )
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateInstruction(specialInstructions) {
  try {
    const response = await api.post(
      `/update_lead_${atob(constantName)}_special_instruction`,
      specialInstructions
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteInstruction(id, instructionsId) {
  const payload = {
    leadId: id,
    leadQuotationSpecialInstructionId: instructionsId,
  }
  return api
    .post(`/delete_lead_${atob(constantName)}_special_instruction`, payload)
    .catch((error) => Promise.reject(error))
}

//Photography Event

/**
 *
 * @param {integer} id
 * @returns
 */

export function loadPhotography(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_${atob(constantName)}_check_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createPhotography(checklist) {
  console.log("inside api call------------", checklist)
  try {
    const response = await api.post(
      `/add_lead_${atob(constantName)}_check_list`,
      checklist
    )
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updatePhotography(checklist) {
  try {
    const response = await api.post(
      `/update_lead_${atob(constantName)}_check_list`,
      checklist
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deletePhotography(id, eventChecklistId) {
  const payload = { leadId: id, leadQuotationCheckListId: eventChecklistId }
  return api
    .post(`/delete_lead_${atob(constantName)}_check_list`, payload)
    .catch((error) => Promise.reject(error))
}

//Total Service Count

/**
 *
 * @param {integer} id
 * @returns
 */

export function loadServiceTotal(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_${atob(constantName)}_service_account`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function approvalRequestQc(id, leadQuotationId) {
  const payload = { leadId: id, leadQuotationId: leadQuotationId }
  return api
    .post(`/request_qc_approval`, payload)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function updateReapproveQc(qcRequestData) {
  return api
    .put(`/update_approval_qc`, qcRequestData)
    .catch((error) => Promise.reject(error))
}

export function loadQuotationHistoryDetails(record) {
  console.log("loadQuotationHistoryDetails Remote==>", record)

  return api
    .post(`/get_${atob(constantName)}_history`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadSalesApproval() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_pending_qc`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_filter`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Qc history
export function loadQcHistoryDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_qc_history_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Quotation details
export async function updateQuotationList(quotationList) {
  try {
    console.log("Updated Api data ---> ")

    const response = await api.post(
      `/update_lead_quotation_flag`,
      quotationList
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadQuotationList(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_quotation_detail`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

// Layout Master Api list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadQCLayoutMaster(payloadLayoutMaster) {
  return api
    .post(`/get_all_layout_master`, payloadLayoutMaster)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadQCLayoutSegment() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_layout_segment`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Quotation Preview

/**
 *
 * @param {integer} id
 * @returns
 */

export function loadQuotationPreviewDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_quotation_preview`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function updateQuotationPreviewDetails(quotationPreview) {
  return api
    .post(`/update_lead_is_preview_shown`, quotationPreview)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function addSegmentPreviewDetails(segmentPreview) {
  return api
    .post(`/add_segment_id`, segmentPreview)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function addProductAPI(product_details) {
  return api
    .post(`/add_reassign_production_quotation_deliverable`, product_details)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function addTeamAPI(team_details) {
  return api
    .post(
      `/add_reassign_employee_production_quotation_deliverable`,
      team_details
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function updateCrmDeliverAPI(crmDeliver) {
  return api
    .post(`/crm_deliverable_updateAPI`, crmDeliver)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadDeliverableEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_dropdown_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function updateDiscountPreviewDetails(discountPreview) {
  return api
    .post(`/update_preview_discount_lead`, discountPreview)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export  function updateProcessAPI(submitStatus) {
  return  api
    .post(`/update_processStatus_history`, submitStatus)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function addCrmAssignApi(crm_details) {
 
  return api
    .post(`/add_assign_crm_employee_production_quotation_deliverable`, crm_details)
    .catch((error) => Promise.reject(error))
}
export function loadProcessStatusApi() {
  return api
    .post(`/get_all_process_status`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadDeliverableRecordsMetaDataDetails,
  loadInstructionsRecordsMetaDataDetails,
  loadRecordQuotationDetails,
  createQuotationRecord,
  updateQuotationRecord,
  deleteQuotationRecord,
  loadDeliverableDetails,
  createDeliverable,
  updateDeliverable,
  deleteDeliverable,
  loadServiceDetails,

  loadValueInsertDetails,
  createValueInsertDetails,
  updateValueInsertDetails,
  deleteValueInsertDetails,

  updateExpiryDateDetails,

  loadInstructions,
  createInstruction,
  updateInstruction,
  deleteInstruction,

  loadPhotography,
  createPhotography,
  updatePhotography,
  deletePhotography,
  loadServiceTotal,

  approvalRequestQc,
  updateReapproveQc,

  loadQuotationHistoryDetails,

  loadSalesApproval,
  loadEmployeeList,
  loadQcHistoryDetails,

  loadQCLayoutMaster,
  updateQuotationList,
  loadQuotationList,
  loadQCLayoutSegment,

  // quotation preview
  loadQuotationPreviewDetails,
  updateQuotationPreviewDetails,

  addProductAPI,
  addTeamAPI,
  updateCrmDeliverAPI,

  loadDeliverableECDetailsData,
  loadDeliverableEmployeeList,

  //Discount preview
  updateDiscountPreviewDetails,
  updateProcessAPI,
  addCrmAssignApi,
  loadProcessStatusApi,
}

export default remotes
